import { Routes } from '@angular/router';

/**
 * `preload: true`: the pages the header and the home link to; their code is fetched in the
 * background once the first page has settled (shared/routing/idle-preloading.ts), so moving
 * between them is instant. The legal pages, checkout and articles load when opened.
 */
export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home').then((m) => m.HomePage),
    data: { seoKey: 'home', preload: true },
  },
  {
    path: 'meet-ali',
    loadComponent: () => import('./pages/meet-ali/meet-ali').then((m) => m.MeetAliPage),
    data: { seoKey: 'meetAli', preload: true },
  },
  // "Try Ali free" is Meet Ali now: the old chat's address (ads, emails, bookmarks) lands
  // there with its query (?from, ?entry, ?ref) intact
  { path: 'chat-with-ali', redirectTo: 'meet-ali', pathMatch: 'full' },
  {
    path: 'campaign-preview/customer-profile',
    loadChildren: () => import('./features/campaign-preview/campaign-preview.routes'),
  },
  {
    path: 'company',
    loadComponent: () =>
      import('./pages/mohamad/company/company').then((m) => m.MohamadCompanyPage),
    data: { seoKey: 'company', preload: true },
  },
  {
    path: 'referral',
    loadComponent: () =>
      import('./pages/mohamad/referral/referral').then((m) => m.MohamadReferralPage),
    data: { seoKey: 'referral', preload: true },
  },
  {
    path: 'pricing',
    loadComponent: () =>
      import('./pages/mohamad/pricing/pricing').then((m) => m.MohamadPricingPage),
    data: { seoKey: 'pricing', preload: true },
  },
  {
    path: 'payment-checkout',
    loadComponent: () =>
      import('./pages/payment-checkout/payment-checkout').then((m) => m.PaymentCheckout),
    data: { seoKey: 'paymentCheckout' },
  },
  {
    path: 'products/ali-sales-reps',
    loadComponent: () =>
      import('./pages/mohamad/product/product').then((m) => m.MohamadProductPage),
    data: { seoKey: 'aliSalesReps', preload: true },
  },
  {
    path: 'products/skilled-networking',
    loadComponent: () =>
      import('./pages/mohamad/skilled-card/skilled-card').then((m) => m.MohamadSkilledCardPage),
    data: { seoKey: 'skilledCard', preload: true },
  },
  { path: 'products/skilled-card', redirectTo: 'products/skilled-networking', pathMatch: 'full' },
  { path: 'ali', redirectTo: 'products/ali-sales-reps', pathMatch: 'full' },
  {
    path: 'compare',
    loadComponent: () =>
      import('./pages/mohamad/compare/compare').then((m) => m.MohamadComparePage),
    data: { seoKey: 'compare', preload: true },
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./pages/mohamad/privacy/privacy').then((m) => m.MohamadPrivacyPage),
    data: { seoKey: 'privacyPolicy' },
  },
  {
    path: 'terms-of-use',
    loadComponent: () =>
      import('./pages/mohamad/terms/terms').then((m) => m.MohamadTermsPage),
    data: { seoKey: 'termsOfUse' },
  },
  {
    path: 'pdpl',
    loadComponent: () =>
      import('./pages/mohamad/pdpl/pdpl').then((m) => m.MohamadPdplPage),
    data: { seoKey: 'privacyPolicy' },
  },
  {
    path: 'dont-use-my-information',
    loadComponent: () =>
      import('./pages/mohamad/data-request/data-request').then((m) => m.MohamadDataRequestPage),
    data: { seoKey: 'dontUseMyInformation' },
  },
  {
    path: 'content-hub',
    loadComponent: () =>
      import('./pages/mohamad/resources/resources').then((m) => m.MohamadResourcesPage),
    data: { seoKey: 'contentHub', preload: true },
  },
  {
    path: 'content-hub/:slug',
    loadComponent: () =>
      import('./pages/content-hub/content-hub-detail-page').then((m) => m.ContentHubDetailPage),
    data: { seoKey: 'article' },
  },
  { path: '**', redirectTo: '' },
];
